import React from 'react';
import PropTypes from 'prop-types';
import SharePieChart from './SharePieChart';

const CommitShareChart = ({ data }) => {
    // Filter out entries with zero commits
    const chartData = data.filter(element => element.totalCommits > 0);

    return chartData.length > 0 ? (
            <SharePieChart
                chartData={chartData}
                dataKey='totalCommits'
                labelFunction={(payload) => payload.totalCommits}
                type="commit"
                title="Commits by Developers"
            />
    ) : (null)
};

// Define PropTypes for the component
CommitShareChart.propTypes = {
    data: PropTypes.array.isRequired,
};

export default CommitShareChart;
